import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { salesCampaignPageQueryOptions } from "~/app/api/pageData/salesCampaignPageQuery";
import type { SalesCampaignPageInitialData } from "~/app/api/pageData/salesCampaignPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createSalesCampaignPage } from "~/pages/SalesCampaignPage/SalesCampaignPage";

function SalesCampaignRoute() {
  const result = useLoaderData({
    from: "/campaign",
  }) as PageInitialData<SalesCampaignPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createSalesCampaignPage(result.data.showRelevantToggle)}
    </StorefrontShellFrame>
  );
}

export async function loadSalesCampaignPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(salesCampaignPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const salesCampaignRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/campaign",
  loader: async ({ context }) => loadSalesCampaignPageData(context),
  component: SalesCampaignRoute,
});
